import { z } from "zod";

import copyJson from "./address-copy.json";

const copySchema = z.object({
  initialLabel: z.string().min(1),
  errors: z.object({
    addressNotFound: z.string().min(1),
    contactNotFound: z.string().min(1),
    contactAddress: z.string().min(1),
    companyAddress: z.string().min(1),
  }),
});

const copy = copySchema.parse(copyJson);

export const ADDRESS_ERROR_MESSAGES = copy.errors;
export const INITIAL_ADDRESS_LABEL = copy.initialLabel;
